import React from "react";

export default function ScreenHeader({ eyebrow, title, subtitle, right, testid = "screen-header" }) {
  return (
    <header
      className="pt-10 pb-6 px-6 animate-fade-up"
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-sage-700 mb-2">
              {eyebrow}
            </p>
          )}
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-ink">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1.5 text-sm text-muted2 leading-relaxed">{subtitle}</p>
          )}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
    </header>
  );
}
